import DigitalmediaPage from "./digitalmedia.page"

export default DigitalmediaPage;
